import { Box, Stack, styled, Typography } from '@planne-software/uni/mui/material';

export const AdditionalCardRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-xs'],
  padding: theme.tokens.spacing['spacing-xs'],
  borderRadius: theme.tokens.radius['border-radius-xs'],
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: selected
    ? theme.tokens.colors['border-color-primary-base']
    : theme.tokens.colors['border-color-neutral-soft'],
  backgroundColor: selected
    ? theme.tokens.colors['fill-color-primary-softest']
    : theme.tokens.colors['fill-color-neutral'],
}));

export const CardHeaderRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 12,
});

export const CardMain = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 4,
  flex: 1,
  minWidth: 0,
});

export const AvatarWrap = styled(Box)({
  position: 'relative',
  width: 48,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  borderRadius: '50%',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const AvatarBorder = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  borderRadius: '50%',
  border: `1px solid ${theme.tokens.colors['border-color-neutral-strong']}`,
  pointerEvents: 'none',
}));

export const TextColumn = styled(Stack)({
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flex: 1,
  minWidth: 0,
  gap: 0,
});

export const TitleText = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-neutral-strong'],
}));

export const MetaText = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-xs-regular'],
  color: theme.tokens.colors['text-color-neutral-strong'],
}));

export const StatusText = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-xs-medium'],
  color: theme.tokens.colors['text-color-neutral-strong'],
}));

export const DescriptionSection = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
  gap: theme.tokens.spacing['spacing-1xmini'],

  '@media (min-width: 600px)': {
    maxWidth: '37.125rem',
  },

  '@media (min-width: 1000px)': {
    maxWidth: '18.125rem',
  },
}));

export const DescriptionDivider = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 0,
  borderTop: `1px solid ${theme.tokens.colors['border-color-neutral-soft']}`,
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-regular'],
  color: theme.tokens.colors['text-color-neutral-strong'],
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}));

export const CheckboxOuter = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  width: 20,
  height: 20,
  flexShrink: 0,
  borderRadius: 6,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: selected
    ? theme.tokens.colors['border-color-primary-base']
    : theme.tokens.colors['border-color-neutral-strong'],
  backgroundColor: selected
    ? theme.tokens.colors['fill-color-primary-softest']
    : theme.tokens.colors['fill-color-neutral'],

  '& svg': {
    color: selected
      ? theme.tokens.colors['border-color-primary-base']
      : theme.tokens.colors['border-color-neutral-strong'],
  },
}));
